module.exports = __webpack_public_path__ + "media/alaska/green_top-7bb1d13f.jpg";